import { Reducer } from "redux";
import { CoverageItem } from "./Insurance";

export interface SingleRecommendationState {
  title: string;
  readMore: {
    text: string;
    linkText: string;
    title: string;
  };
  text: string;
  coverageItems: CoverageItem[];
}

const defaults: SingleRecommendationState = {
  // localize;
  title: "Vi rekomenderar",
  text: "Vi rekomenderar halvförsakring så länge bilen har personvagnsgaranti. Din Polestar har 3 års personvagnsgaranti.",
  readMore: {
    linkText: "Läs mer",
    text: "test",
    title: "Test",
  },
  coverageItems: [
    { Name: "Item 1", InternalCode: "1" } as CoverageItem,
    { Name: "Item 2", InternalCode: "2" } as CoverageItem,
    { Name: "Item 3", InternalCode: "3" } as CoverageItem,
    { Name: "Item 4", InternalCode: "4" } as CoverageItem,
    { Name: "Item 5", InternalCode: "5" } as CoverageItem,
    { Name: "Item 6", InternalCode: "6" } as CoverageItem,
    { Name: "Item 7", InternalCode: "7" } as CoverageItem,
  ],
};

export const reducer: Reducer<SingleRecommendationState> = (state: SingleRecommendationState = defaults): SingleRecommendationState => {
  return state;
};
